import { Component } from 'react';


import ComponentVideo from "GeneralComponents/ComponentVideo";

import { MediaItem } from "Interfaces/general.interface";

import Consts from "Interfaces/Consts";


import "./VideoBanner.css";



export default class VideoBannerItem extends Component {

    props: any;

    state: {
        index: string;
        movie: MediaItem;
        mobileMovie: MediaItem;
        isVideoLoop: boolean;
    }



    constructor(props) {
        super(props);

        this.state = {

            index: this.props.bannerItem.index,
            movie: this.props.bannerItem.imageOrMovie as MediaItem,
            mobileMovie: this.props.bannerItem.mobileImageOrMovie as MediaItem,
            isVideoLoop: this.props.isVideoLoop


        };

        if (this.state.movie.url && !this.state.mobileMovie.url) {
            this.state.mobileMovie = { ...this.state.movie };
        }
    }


    render() {

       
        return (
            <>
                {
                    (this.state.movie.url && !this.state.movie.isImage) &&

                    <ComponentVideo
                        video={this.state.movie}
                        videoClass="d-none d-md-block d-lg-block video-fluid "
                        withControls={true}
                        autoPlay={true}
                        wrapperDivClass="mst-Banner-Video"
                        cancelLoop={!this.state.isVideoLoop}
                    />
                }
                {
                    (this.state.mobileMovie.url && !this.state.mobileMovie.isImage) &&

                    <ComponentVideo
                        video={this.state.mobileMovie}
                        videoClass=" d-block d-md-none d-lg-none video-fluid "
                        withControls={true}
                        autoPlay={true}
                        wrapperDivClass="mst-Banner-Video"
                        cancelLoop={!this.state.isVideoLoop}
                    />
                }
            </>

        );
    }
}
